<template>
	<div class="container">
		<Navigation-bar title="搜索"></Navigation-bar>
		<div class="container_content">
            <div class="nav_bar" v-scrollShadow="scrollTop">
                <div class="search">
                    <div class="value">
                        <div>
                            <form @submit.prevent="search" action="javascript:return true;">
                                <input type="search" v-model="searchValue" ref="searchValue" placeholder="姓名/身份证号/证书编号">
                            </form>
                            <YD-image src="icon/icon_search" class="icon"></YD-image>
                        </div>
                    </div>
                    <span @click="$navigation.back()">取消</span>
                </div>
                <div class="num">
                    <span>共<i>{{allCount}}</i>个搜索结果</span>
                </div>
            </div>
            <div id="Referee_Search">
				<Scroll :scroll.sync="scrollTop" @scrollEnd="scrollEnd()">
					<div class="list">
                        <div class="list_item" v-for="(item,index) in list" :key="index" @click="go2Detail(item.RefereeId)">
                            <div class="item-portrait">
                                <img :src="item.PortraitPhoto" v-if="item.PortraitPhoto">
                                <img class="default" :src="getPortraitDefault(item.Gender)" v-else>
                            </div>
                            <div class="item-body">
                                <div class="item-name">{{item.Name}}</div>
                                <div class="item-location">
                                    <template v-if="item.AddressInfo.Country == '中国'">
                                        <template v-if="item.AddressInfo.Region">{{item.AddressInfo.Region.RegionName || '未知'}}</template>
                                        <template v-else>未知</template>
                                    </template>
                                    <template v-else>{{item.AddressInfo.Country || '未知'}}</template>
                                </div>
                                <div class="item-level">{{item.EventsName}}{{item.CurrentLevelName || ''}}裁判员</div>
                            </div>
                        </div>
					</div>
					<Text-prompt noDataImg="no_data/暂无内容@2x.png" :text="loadMore"></Text-prompt>
				</Scroll>
			</div>
		</div>
	</div>
</template>

<script>
	import {
		GetRefereeList
	} from '@/api';
	export default {
		name: "RefereeSearch",
		data() {
			return {
				scrollTop: 0,
				searchValue: '',
				allCount: 0,
				list: [],
				loadMore: ""
			};
		},
		computed: {
			/// 获取赛事中最后一个Id
			lastId() {
				let length = this.list.length;
				if (length > 0) {
					return this.list[length - 1].RefereeId;
				}
				return 0;
			}
		},
		methods: {
			getPortraitDefault(gender){
				if(gender == 2){
					return require("@/assets/occupation/images/list_portrait_default_woman@2x.png");
				}
				return require("@/assets/occupation/images/list_portrait_default_man@2x.png");
			},
			search(){
				this.getDataList(true);
				this.$refs['searchValue'].blur();
			},
			scrollEnd(){
				this.getDataList();
			},
			getDataList(isReload = false) {
				if(!isReload && ['到底了', '加载中'].includes(this.loadMore)) return;
				this.loadMore = "加载中";
				let lastId = isReload ? 0 : this.lastId;
				let param = {
					EventsId: 0,
					LevelNo: 0,
					Gender: 0,
					ProvinceCode: 0,
					Keyword: this.searchValue,
					Continuation: {
						LastId: lastId,
						MaxCount: 20
					}
				};
				GetRefereeList(param).then(data => {
					this.loadMore = "加载更多";
					if (data.Code === 0) {
						this.allCount = data.AllCount;
						let list = data.ContinueList || [];
						
                        if(isReload){
							this.scrollTop = 0;
                        }
                        if(list.length == 0){
							if(isReload){
								this.list = [];
								this.loadMore = "无数据";
							}else{
								this.loadMore = '到底了';
							}
						}else{
							if(isReload) {
								this.list = list;
								if(list.length < 20){
									this.loadMore = '';
								}
							}else {
								this.list.push(...list);
                                if(this.list.length == this.allCount){
                                    this.loadMore = "到底了";
                                }
							}
						}
					}
				});
			},
            go2Detail(id){
                this.$navigation.go(`/Occupation/RefereeDetail/${id}`)
            }
		}
	}
</script>
<style lang="scss" scoped>
@import "@/assets/occupation/scss/refereeCenter.scss";

.nav_bar{
    width: 100%;
    height: 160px;
    padding: 8px 40px 0;
    box-sizing: border-box;
    position: relative;
    z-index: 2;
    .search{
        height: 72px;
        width: 100%;
        display: flex;
        justify-content: space-between;
        align-items: center;
        .value{
            width: 598px;
            height: 72px;
            background: #FAFBFA;
            border-radius: 36px;
            display: flex;
            align-items: center;
            justify-content: space-between;
            padding: 0 8px 0 16px;
            box-sizing: border-box;
            >div{
                width: 100%;
                height: 48px;
                position: relative;
                img{
                    width: 48px;
                    height: 48px;
                    position: absolute;
                    top: 0;
                    &.icon{
                        left: 0;
                    }
                }
                form{
                    width: 100%;
                }
                input{
                    width: 100%;
                    height: 48px;
                    padding-left: 56px;
                    box-sizing: border-box;
                    display: block;
                    font-size: 28px;
                    color: #1B1C1E;
                    font-weight: 400;
                }
            }
        }
        >span{
            font-size: 28px;
            color: #1B1C1E;
            font-weight: 400;
        }
    }
    .num{
        height: 72px;
        width: 100%;
        font-size: 26px;
        color: #666666;
        letter-spacing: 0;
        line-height: 40px;
        font-weight: 400;
        margin-top: 8px;
        display: flex;
        align-items: center;
        justify-content: space-between;
        &::after,
        &::before{
            content:'';
            flex: 1;
            border-bottom:1px #E5E5E5 solid;
        }
        span{
            margin: 0 24px;
        }
        i{
            font-weight: 500;
            color: #1B1C1E;
        }
    }
}
#Referee_Search{
	height: calc(100% - 160px);
}
</style>